import { createSlice } from "@reduxjs/toolkit";
import { setLocalItems, removeLocalItems } from "../../helpers/storedItems";

const initialState = {
  token: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginAccount: (state, action) => {
      const { token: accessToken, claims } = action.payload;
      const token = accessToken.access_token;

      setLocalItems("auth0-token-storage", accessToken);
      setLocalItems("user-claims", claims);

      state.token = token;
    },

    logout: (state) => {
      removeLocalItems("auth0-token-storage");
      removeLocalItems("user-claims");
      state.token = null;
    },
  },
});

export const { loginAccount, logout } = authSlice.actions;
export default authSlice.reducer;
